import React from 'react';
import { Typography } from '../../../atoms/typography/Typography';
import { Stack } from '../../../atoms/stack/Stack';
import { StyledHtmlDiv } from '../../../atoms/styledHtmlDiv/StyledHtmlDiv';

const AboutSystem = ({ section }) => (
  <div className="flex w-full flex-col flex-1 px-8 lg:mx-auto my-10 max-w-7xl">
    <div className="flex flex-col flex-1 gap-10 md:gap-3 py-5 items-center">
      <Typography as="h4" fontVariant="h4">
        {section.componentData.title}
      </Typography>
      <div className="flex flex-col md:flex-row w-full max-w-3xl gap-10 md:gap-20 p-10">
        <Stack className="justify-center items-center">
          <img
            className="w-[150px] h-[150px] min-w-[150px]"
            src={section.componentData.imgUrl}
            alt={section.componentData.imgAlt}
          />
        </Stack>
        <StyledHtmlDiv
          className="max-w-full md:max-w-md text-clamp-lg font-light normal-case text-center md:text-left !text-customGray-600"
          content={section.componentData.description}
        />
      </div>
    </div>
  </div>
);

export default AboutSystem;
